import { LandingPage } from './pages/LandingPage';
export function App() {
  return <LandingPage data-id="element-0" data-mp="odreir0tj1hq" />;
}